export class Constants {
    static CONST_ID_PRIMARY = 'primary';
    static CONST_ID_CO_APPLICANT = 'coApplicant';

    static CONST_ID_SALARIED = 'salaried';
    static CONST_ID_SELF_EMPLOYED = 'selfEmployed';

    static CONST_ID_INDIVIDUAL = 'Individual';
    static CONST_ID_ORGANISATION = 'Organisation';

    static CONST_ID_PERSONAL = 'PERSONAL';
    static CONST_ID_INCOME = 'INCOME';
    static CONST_ID_LOAN = 'LOAN';
    static CONST_ID_SUBVENTION = 'SUBVENTION';

    static CONST_PERSONAL_INFO_COMPLETED = "CST_APP_PERSONAL";
    static CONST_PERSONAL_INFO_CO_COMPLETED = "CST_APP_COAPP_PERSONAL";

    static CONST_INCOME_INFO_COMPLETED = "CST_APP_INCOME";
    static CONST_INCOME_INFO_CO_COMPLETED = "CST_APP_COAPP_INCOME";
    static CONST_INCOME_CO_COMPLETED = "CST_COAPP_INCOME";

    static CONST_LOAN_FIN_PROD_INFO_COMPLETED = "LOAN_FIN_PROD";
    static CONST_LOAN_FIN_TERMS_INFO_COMPLETED = "LOAN_FIN_TERMS";
    static CONST_LOAN_FIN_SUBVENTION_INFO_COMPLETED = "LOAN_FIN_SUBVENTION";
    static CONST_LOAN_FIN_SUBPROD_INFO_COMPLETED = "LOAN_FIN_SUBPROD";
    static CONST_OTP_GEN = "OTP_GEN";
    static CONST_OTP_SUBMITLATER = "OTP_SUBMIT_LATER";
    static CONST_TRACK_APPLICAIION = "TRACK_APPLN";

    static CONST_ID_NEWCARQUOTE = 'NEWCARQUOTE';
    static CONST_ID_USEDCARQUOTE = 'USEDCARQUOTE';
    static CONST_ID_SEARCHCARQUOTE = 'SEARCHCARQUOTE';
    static CONST_ID_TRACKCARQUOTE = 'TRACKCARQUOTE';
    static CONST_ID_RECENT = 'RECENT';
    static CONST_ID_NOTIFICATION = 'NOTIFICATION';
    static CONST_ID_REPORTS = 'REPORTS';
    static CONST_ID_MASTER = 'MASTER';

    static CONST_ID_STATUS = 'STATUS';
    static CONST_ID_WORKLOAD = 'WORKLOAD';

    static CONST_ID_DEALER = 'DEALER';
    static CONST_ID_CUSTOMER = 'CUSTOMER';

    static CONST_ID_HOME = 'HOME';

    static CONST_ID_DATA_SYNC = 'DATASYNC';
    static CONST_ID_BROADCAST = 'BROADCAST';
    static CONST_ID_USERADMIN = 'USERADMIN';
    static CONST_ID_DASHBOARDADMIN = 'DASHBOARDADMIN';
    static CONST_ID_CONFIGADMIN = 'CONFIGADMIN';
    static CONST_ID_IMAGEUPLOAD = 'IMAGEUPLOAD';
    static CONST_ID_TASKMANAGER = 'TASKMANAGER';
    static CONST_ID_FAQ = 'FAQ';
    static CONST_ID_DEALERDATA = 'DEALERDATA';

}
